import { Component, input, output } from '@angular/core';

@Component({
  selector: 'syn-candidate-actions',
  templateUrl: './candidate-actions.component.html',
  styleUrls: ['./candidate-actions.component.scss'],
})
export class CandidateActionsComponent {
  readonly _create = output<void>();
  readonly _remind = output<void>();
  readonly remindDisabled = input(false);

  createCandidate() {
    // TODO: The 'emit' function requires a mandatory void argument
    this._create.emit();
  }
}
